// extracted by mini-css-extract-plugin
export default {"aiart":"aiart_aiart__LNQFF","art-list":"aiart_art-list__s0KVQ","row":"aiart_row__biesb"};